import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import ec from "@/i18n/ec.json";

export default function ThankYou() {
  const d = ec.thankYou;
  return (
    <main
      data-testid="page-thank-you"
      className="min-h-[70vh] bg-slate-50 flex items-center"
    >
      <div className="mx-auto max-w-2xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-teal-600 text-white">
          <CheckCircle2 className="h-8 w-8" />
        </div>
        <p className="mt-6 text-xs font-semibold uppercase tracking-[0.18em] text-teal-700">
          {d.eyebrow}
        </p>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
          {d.title}
        </h1>
        <p className="mt-4 text-base sm:text-lg leading-relaxed text-slate-700">
          {d.body}
        </p>
        <p className="mt-3 text-sm text-slate-500">{d.note}</p>
        <div className="mt-8">
          <Link
            to="/"
            data-testid="thank-you-back-home"
            className="inline-flex items-center gap-2 rounded-md bg-slate-900 px-6 py-3 text-sm font-semibold text-white hover:bg-slate-800"
          >
            <ArrowLeft className="h-4 w-4" />
            {d.back}
          </Link>
        </div>

        <div className="mt-16 border-t border-slate-200 pt-8 text-xs text-slate-500">
          <p>Chasquifund S.A.S. — RUC 1793148291001</p>
          <p>© 2026 Chasquifund S.A.S.</p>
        </div>
      </div>
    </main>
  );
}
